module.exports = __webpack_public_path__ + "static/media/3.fc2f5977.jpg";